module.exports = __webpack_public_path__ + "img/coupon-bg.d9dffc5a.png";